.quantityButton {
  width: 100%;
  margin-left: auto;
}
